import { render, staticRenderFns } from "./select_delete.vue?vue&type=template&id=f66ada54&"
import script from "./select_delete.vue?vue&type=script&lang=js&"
export * from "./select_delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports